import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ArchiveIcon from "@mui/icons-material/Archive";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FilterListIcon from "@mui/icons-material/FilterList";
import ForumIcon from "@mui/icons-material/Forum";
import GroupIcon from "@mui/icons-material/Group";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import MessageIcon from "@mui/icons-material/Message";
import PageviewIcon from "@mui/icons-material/Pageview";
import PersonIcon from "@mui/icons-material/Person";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import WorkIcon from "@mui/icons-material/Work";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled, SxProps, Theme } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import EmptyInboxPlaceholder from "app/assets/empty_inbox_placeholder.svg";
import { useDialog } from "app/providers/dialog";
import { useAttorneyHubDispatch } from "app/realtime-store/redux-store";
import { NotificationTag } from "app/routes/communications/style";
import { NotAuthorized } from "common/components/not-authorized";
import { OrderDirection } from "common/contracts/order-direction";
import PaginationParameters from "common/contracts/pagination-parameters";
import * as Constants from "common/helpers/constants";
import Guid from "common/values/guid/guid";
import {
  getIndividualByUserId,
  getIndividualIsLoadingByUserId,
  populateIndividuals
} from "marketplace/entities/individual/realtime-store/individuals-redux-slice";
import {
  type MRT_ColumnFiltersState as ColumnFiltersState,
  createMRTColumnHelper,
  MaterialReactTable,
  type MRT_PaginationState as PaginationState,
  type MRT_RowData as RowData,
  MRT_ShowHideColumnsButton as ShowHideColumnsButton,
  type MRT_TableInstance as TableInstance,
  MRT_ToggleDensePaddingButton as ToggleDensePaddingButton,
  MRT_ToggleFiltersButton as ToggleFiltersButton,
  MRT_ToggleFullScreenButton as ToggleFullScreenButton,
  MRT_ToggleGlobalFilterButton as ToggleGlobalFilterButton,
  useMaterialReactTable,
} from "material-react-table";
import { ChatDialog } from "messaging/components";
import Forum from "messaging/entities/forum/forum";
import ConversationTable from "messaging/entities/forum/view/components/conversation-table";
import CreateForumDialog from "messaging/entities/forum/view/components/create-forum-dialog";
import moment from "moment";
import MessageNotification from "notifications/entities/message-notification/message-notification";
import NotificationsAPIService, {
  NotificationNotFoundError,
} from "notifications/entities/notification/api/notifications-api-service";
import NotificationQuery, {
  NotificationFilterParameters,
  NotificationOrderField,
  NotificationOrderParameters
} from "notifications/entities/notification/api/request-contracts/query-notifications-api-request";
import Notification from "notifications/entities/notification/notification";
import { NotificationLink } from "notifications/entities/notification/notification-type";
import {
  addNotification,
  getErrorLoadingNotificationsByQuery,
  getIsLoadingNotificationsByQuery,
  getNotificationQueryByInterface,
  getNotificationsByQuery,
  populateNotificationsByQuery,
  updateNotificationInterfaceQuery,
} from "notifications/entities/notification/store/notifications-redux-slice";
import Action from "notifications/values/action/action";
import { BoxType } from "notifications/values/box-type/box-type";
import TopicCategory from "notifications/values/topic-category/topic-category";
import { enqueueSnackbar } from "notistack";
import React, { JSX, useEffect, useState } from "react";
import { useLoaderData, useNavigate, useSearchParams, } from "react-router-dom";
import { useSession } from "users/session/session-context";


const NoRowsContainer = styled("div")(
  () => ({
    display: "flex",
    justifyContent: "center",
  }));
const RowActionsContainer = styled(Box)(
  () => ({
    display: "flex",
    flexWrap: "nowrap",
    width: "inherit",
  }));
const ToolbarButtonsContainer = styled("div")(
  ({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
    },
    display: "flex",
    alignItems: "end",
    flexDirection: "column",
    gap: theme.spacing(1),
  }));
const ToolbarButtons = styled("div")(
  () => ({
    display: "flex",
    alignItems: "end",
    flexWrap: "nowrap",
  }));
const ToolbarActionButtons = styled("div")(
  () => ({
    textAlign: "right",
    whiteSpace: "nowrap",
  }));
const CategoryItem = styled(ListItem)(
  () => ({
    margin: 0,
    padding: 0,
  }));
const AlertActions = styled("div")(
  ({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "nowrap",
    height: "100%",
    paddingRight: theme.spacing(2),
    whiteSpace: "nowrap",
  }));
const AllCaughtUp = styled("img")(
  ({ theme }) => ({
    maxHeight: "100px",
    padding: theme.spacing(2),
  }));
const TableTopToolbarContainer = styled("div")(
  () => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
  }));
const LowerTopToolbarContainer = styled("div")(
  ({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
    display: "flex",
    flexDirection: "row",
    alignItems: "left",
    width: "100%",
  }));
const TableTitle = styled(Typography)(
  ({ theme }) => ({
    paddingLeft: theme.spacing(1),
  }));
const FilterButtons = styled("div")(
  ({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing(1),
    "& > .MuiChip-root": {
      [theme.breakpoints.down("xl")]: {
        marginBottom: theme.spacing(0.5),
      },
      marginLeft: theme.spacing(0.5),
    },
  }));
const TableTitleContainer = styled("div")(
  () => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  }));
const NewForumButton = styled(IconButton)(
  ({ theme }) => ({
    padding: 0,
    paddingRight: theme.spacing(1),
  }));
const ComposeMessageButton = styled(IconButton)(
  ({ theme }) => ({
    padding: 0,
    paddingRight: theme.spacing(1),
  }));

const SenderCell = ({
  senderUserId,
  senderName,
}: {
  senderUserId: Guid;
  senderName?: string;
}) => {
  if (senderName) return <>{senderName}</>;
  const isLoadingIndividual = getIndividualIsLoadingByUserId(senderUserId);
  const sender = getIndividualByUserId(senderUserId);
  if (isLoadingIndividual && !sender) return <>Loading...</>;
  if (!sender) return <Icon>remove</Icon>;

  return <>{sender.getFullName()}</>;
};

const RecipientsCell = ({
  recipientUserIds,
  recipientName
}: {
  recipientUserIds?: Guid[],
  recipientName?: string
}) => {
  if (recipientName) return <>{recipientName}</>;
  if (!recipientUserIds || recipientUserIds.length === 0) return <Icon>remove</Icon>;
  const isLoadingIndividual = recipientUserIds?.some((recipientUserId) =>
    getIndividualIsLoadingByUserId(recipientUserId)
  );
  const recipients = recipientUserIds?.map((recipientUserId) =>
    getIndividualByUserId(recipientUserId)
  );

  if (isLoadingIndividual && !recipients) return <>Loading...</>;
  if (!recipients) return <Icon>remove</Icon>;

  return (
    <>
      {recipients.map((recipient, index) => {
        if (!recipient) return null;
        return (
          <React.Fragment key={recipient?.id.value}>
            {recipient.getFullName()}
            {index < recipients.length - 1 && ", "}
          </React.Fragment>
        );
      })}
    </>
  );
}

export default function Communications() {
  const [activeTab, setActiveTab] = React.useState(BoxType.Inbox);
  const [filterByActionRequired, setFilterByActionRequired] = React.useState<boolean | undefined>();
  const [filterByUnread, setFilterByUnread] = React.useState<boolean | undefined>();

  const [isLoading, setIsLoading] = useState(true);
  const [showAlertBanner, setShowAlertBanner] = useState(false);
  const [showSkeletons, setShowSkeletons] = useState(false);
  const [showProgressBars, setShowProgressBars] = useState(false);
  const [rowSelection, setRowSelection] = React.useState<
    Record<string, boolean>
  >({});

  const [globalFilter, setGlobalFilter] = useState("");
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>(
    []
  );
  const [sorting, setSorting] = useState<Array<{ id: string, desc: boolean }>>([]);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10
  });
  const [tableData, setTableData] = useState<Notification[]>([]);
  const [rowCount, setRowCount] = useState(0);


  const routeParams = useLoaderData();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const session = useSession();
  const { numDialogs, openDialog } = useDialog();
  const isSmlDisplaySize = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const isMedDisplaySize = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  const interfaceName = "communicationsIndex"

  const dispatch = useAttorneyHubDispatch();
  const notificationQuery = getNotificationQueryByInterface(
    interfaceName
  );
  const notificationsResponse = getNotificationsByQuery(notificationQuery);
  const queryIsLoading = getIsLoadingNotificationsByQuery(notificationQuery);
  const errorLoadingQuery = getErrorLoadingNotificationsByQuery(notificationQuery);
  const defaultQuery = new NotificationQuery(
    new NotificationFilterParameters(
      {
        query: globalFilter,
        boxType: activeTab,
        isActionRequired: filterByActionRequired,
        isUnread: filterByUnread,
      }
    ),
    new NotificationOrderParameters(
      NotificationOrderField.CreatedDate,
      OrderDirection.Descending
    ),
    new PaginationParameters(0, 25)
  );

  useEffect(
    () => {
      if (!notificationQuery) {
        dispatch(updateNotificationInterfaceQuery({ interfaceName, query: defaultQuery }));
        return;
      }

      if (notificationQuery && notificationsResponse === undefined && !queryIsLoading) {
        dispatch(
          populateNotificationsByQuery({
            session: session,
            query: notificationQuery,
          })
        );
      } else if (notificationsResponse !== undefined) {
        setTableData(notificationsResponse.data);
        setRowCount(notificationsResponse.totalElements);
        setIsLoading(false);
      }
    },
    [
      notificationsResponse,
      notificationQuery,
      activeTab,
      globalFilter
    ]
  );

  useEffect(
    () => {
      if (!notificationsResponse) return;

      const uniqueSenderIds = Array.from(
        new Set(
          notificationsResponse.data
            .map(notification => notification.senderUserId)
            .filter(senderId => senderId !== undefined)
        )
      );

      if (uniqueSenderIds.length > 0) {
        dispatch(
          populateIndividuals({
            session: session,
            userIds: uniqueSenderIds,
          })
        );
      }

      setTableData(notificationsResponse.data);
      setRowCount(notificationsResponse.totalElements);

      setIsLoading(false);
    },
    [notificationsResponse]
  );

  useEffect(
    () => {
      if (queryIsLoading && !isLoading && !showProgressBars) {
        setShowProgressBars(true);
      } else {
        setShowProgressBars(false);
      }
    },
    [queryIsLoading]
  );

  useEffect(
    () => {
      if (errorLoadingQuery) {
        setShowAlertBanner(true);
        setShowSkeletons(true);
        setShowProgressBars(false);
        setIsLoading(false);
        setTableData([]);
      } else {
        setShowAlertBanner(false);
        setShowSkeletons(false);
      }
    },
    [errorLoadingQuery]
  );


  // Handle URL changes
  useEffect(
    () => {
      if (!session.user?.companyEntityId) return;

      if (routeParams.tab) {
        setActiveTab(routeParams.tab as BoxType);
      } else {
        navigate(`/communications/${BoxType.Inbox}`);
        return;
      }

      if (routeParams.action === "create") {
        openCreateForumDialog();
        return;
      }
      if (routeParams.action === "compose") {
        openMessageDialog();
        return;
      }
      if (routeParams.tab === BoxType.Forums) {
          if (routeParams.id) {
            openMessageDialog(new Guid(routeParams.id));
          } else if (routeParams.action) {
            openMessageDialog(new Guid(routeParams.action));
          }
      }
      const filterUnread = searchParams.has("unread") ?
        searchParams.get("unread") === "true" : undefined;
      const filterActionRequired = searchParams.has("actionRequired") ?
        searchParams.get("actionRequired") === "true" : undefined;
      setFilterByUnread(filterUnread);
      setFilterByActionRequired(filterActionRequired);

      const notificationParams = new NotificationFilterParameters(
        {
          query: globalFilter,
          boxType: activeTab,
          isActionRequired: filterActionRequired,
          isUnread: filterUnread,
          type: columnFilters.find((filter) => filter.id === "type")?.value as string,
          from: columnFilters.find((filter) => filter.id === "sender")?.value as string,
          to: columnFilters.find((filter) => filter.id === "recipients")?.value as string,
          description: columnFilters.find((filter) => filter.id === "description")?.value as string,
          minCreatedDate: columnFilters.find((filter) => filter.id === "minCreatedDate")?.value as Date
        }
      );
      const notificationOrderParams = new NotificationOrderParameters(
        sorting.length > 0
          ? sorting[0].id as NotificationOrderField
          : NotificationOrderField.CreatedDate,
        sorting.length > 0 && !sorting[0].desc ? OrderDirection.Ascending : OrderDirection.Descending
      );
      const paginationParams = new PaginationParameters(
        pagination.pageIndex,
        pagination.pageSize
      );
      const newQuery = new NotificationQuery(
        notificationParams,
        notificationOrderParams,
        paginationParams
      );
      if (newQuery.isEqualTo(notificationQuery)) {
        return;
      }
      dispatch(
        updateNotificationInterfaceQuery({
          interfaceName: "communicationsIndex",
          query: newQuery,
        })
      );
    },
    [
      routeParams,
      routeParams.action,
      searchParams,
      pagination.pageIndex,
      pagination.pageSize,
      activeTab,
      sorting,
      globalFilter,
      columnFilters,
      filterByUnread,
      filterByActionRequired
    ]
  );

  async function navigateToTarget(notification: Notification) {
    try {
      if (activeTab === BoxType.Inbox) {
        await new NotificationsAPIService(session).markNotificationAsSeen(
          notification
        );
      }
      navigate(NotificationLink(notification));
    } catch (error) {
      console.error(error);
    }
  }

  async function markMultipleSeen() {
    const selectedRowIds: Guid[] = Object.keys(rowSelection)
      .filter((id) => rowSelection[id])
      .map((id) => new Guid(id));

    try {
      for (const selectedRowId of selectedRowIds) {
        try {
          const updatedNotification = await new NotificationsAPIService(
            session
          ).markNotificationAsSeen(new Notification(selectedRowId));
          dispatch(addNotification(updatedNotification));
        } catch (error) {
          if (error instanceof NotificationNotFoundError) {
            console.error(
              "Unable to mark a deleted notification as read, refreshing to remove",
              error.id
            );
            continue;
          }
          throw error;
        }
      }
      setRowSelection({});
    } catch (error) {
      console.error(error);
    }
  }

  async function markMultipleUnseen() {
    const selectedRowIds: Guid[] = Object.keys(rowSelection)
      .filter((id) => rowSelection[id])
      .map((id) => new Guid(id));

    try {
      for (const selectedRowId of selectedRowIds) {
        try {
          const updatedNotification = await new NotificationsAPIService(
            session
          ).markNotificationAsUnSeen(new Notification(selectedRowId));
          dispatch(addNotification(updatedNotification));
        } catch (error) {
          if (error instanceof NotificationNotFoundError) {
            console.error(
              "Unable to mark a deleted notification as unread, refreshing to remove",
              error.id
            );
            continue;
          }
          console.error(error);
          return;
        }
      }
      setRowSelection({});
    } catch (error) {
      console.error(error);
    }
  }

  async function archiveMultiple() {
    const selectedRowIds: Guid[] = Object.keys(rowSelection)
      .filter((id) => rowSelection[id])
      .map((id) => new Guid(id));

    try {
      for (const selectedRowId of selectedRowIds) {
        try {
          await new NotificationsAPIService(session).archiveNotification(
            new Notification(selectedRowId)
          );
        } catch (error) {
          if (error instanceof NotificationNotFoundError) {
            console.error(
              "Unable to archive a deleted notification, refreshing to remove ",
              error.id
            );
            continue;
          }
          throw error;
        }
      }
      dispatch(
        updateNotificationInterfaceQuery({
          interfaceName: "communicationsIndex",
          query: notificationQuery,
        })
      );
      setRowSelection({});
    } catch (error) {
      console.error(error);
    }
  }

  async function unArchiveMultiple() {
    const selectedRowIds: Guid[] = Object.keys(rowSelection)
      .filter((id) => rowSelection[id])
      .map((id) => new Guid(id));

    try {
      for (const selectedRowId of selectedRowIds) {
        try {
          await new NotificationsAPIService(session).unArchiveNotification(
            new Notification(selectedRowId)
          );
        } catch (error) {
          if (error instanceof NotificationNotFoundError) {
            console.error(
              "Unable to un-archive a deleted notification, refreshing to remove ",
              error.id
            );
            continue;
          }
          console.error(error);
          return;
        }
      }

      setRowSelection({});
      dispatch(
        updateNotificationInterfaceQuery({
          interfaceName: "communicationsIndex",
          query: notificationQuery,
        })
      );
    } catch (error) {
      console.error(error);
    }
  }

  function openCreateForumDialog() {
    if (numDialogs > 0) return;

    const parentPath = new URL(
      ".",
      globalThis.location.origin + globalThis.location.pathname
    );

    openDialog(
      {
        resetStack: true,
        component: (
          <CreateForumDialog
            onForumCreated={(newForum: Forum) => {
              if(!newForum?.id) {
                navigate(parentPath.pathname);
                return;
              }
              navigate(`/communications/forums/${newForum.id.value}`);
              enqueueSnackbar(`Forum ${newForum.name} created`, { variant: "success" });
            }}
          />
        ),
        title: "Create Conversation",
        MuiProps: {
          maxWidth: "md",
        },
      },
      () => navigate(parentPath.pathname)
    );
  }

  function openMessageDialog(id?: Guid) {
    if (numDialogs > 0) return;

    const parentPath = new URL(
      "..",
      globalThis.location.origin + globalThis.location.pathname
    );

    openDialog(
      {
        title: id ? "Message" : "Compose Message",
        resetStack: true,
        MuiProps: {
          fullWidth: true,
          maxWidth: "md",
        },
        contentSxProps: {
          display: "flex",
          overflowX: "hidden",
          paddingBottom: 0,
        },
        component: <ChatDialog forumId={id} />,
      },
      () => navigate(parentPath.pathname)
    );
  }

  function renderCreatedDateColumn(
    notification: Notification
  ): React.ReactNode {
    if (!notification.createdDate) return null;
    return (
      <time>
        {moment(notification.createdDate).format("MM/DD/YY hh:mm A")}
      </time>
    );
  }

  function renderCategoryColumn(notification: Notification) {
    const topicCategory: TopicCategory = notification?.topic?.category ?? "";

    return (
      <CategoryItem dense>
        <ListItemIcon>
          {(topicCategory === TopicCategory.Messaging.Message ||
            topicCategory === TopicCategory.Messaging.ForumInvitation) && (
              <MessageIcon />
            )}
          {topicCategory === TopicCategory.Work.Proposal &&
            !notification.actionRequired && <PersonAddIcon />}
          {topicCategory === TopicCategory.Users.NetworkConnection && (
            <AccountTreeIcon />
          )}
          {topicCategory === TopicCategory.Users.NetworkInvitation && (
            <AccountTreeIcon />
          )}
          {topicCategory === TopicCategory.Work.Proposal &&
            notification.actionRequired &&
            notification.actionRequired !== Action.Review && <AssignmentIcon />}
          {topicCategory === TopicCategory.Work.Proposal &&
            notification.actionRequired === Action.Review && <PageviewIcon />}
          {topicCategory === TopicCategory.Work.Agreement && <WorkIcon />}
          {topicCategory === TopicCategory.Marketplace.Team && <GroupIcon />}
          {topicCategory === TopicCategory.LegalEntities.EntityMember && (
            <PersonIcon />
          )}
          {topicCategory === TopicCategory.Marketplace.TeamInvitation && (
            <GroupAddIcon />
          )}
          {topicCategory === TopicCategory.LegalEntities.LegalEntity && (
            <SupervisorAccountIcon />
          )}
        </ListItemIcon>
        <ListItemText
          primary={
            <strong
              style={{ fontWeight: Notification.isSeen(notification, session.user?.id) ? "normal" : "bold" }}
            >
              {topicCategory === TopicCategory.Messaging.Message
                ? "New Message"
                : Constants.notificationTypes[
                topicCategory as keyof typeof Constants.notificationTypes
                ] ?? "Notification"}
            </strong>
          }
          secondary={
            activeTab === BoxType.Inbox &&
            (Notification.isSeen(notification, session.user?.id)
              ? `Read at ${moment(Notification.seenAt(notification, session.user?.id)).format(
                "MM/DD/YY hh:mm A"
              )}`
              : "Unread notification")
          }
        />
      </CategoryItem>
    );
  }

  function renderDescriptionColumn(notification: Notification) {
    const tag = Notification.hasRecipient(notification, session.user?.id) ? (
      <NotificationTag size="small" label="Received" />
    ) : (
      <NotificationTag size="small" label="Sent" />
    );
    return (
      <>
        {activeTab === BoxType.Archive && tag}
        {notification.message?.value}
      </>
    );
  }

  function renderFromColumn(notification: Notification) {
    let senderName =
      notification instanceof MessageNotification
        ? notification?.messageInfo?.senderName?.value
        : notification?.senderName;

    if (!senderName && notification.senderUserId) {
      senderName = getIndividualByUserId(notification.senderUserId)?.getFullName();
    }
    if (!notification.senderUserId) return <Icon>remove</Icon>;
    return <SenderCell
      senderUserId={notification.senderUserId}
      senderName={senderName}
    />;
  }

  function renderToColumn(notification: Notification) {
    if (notification?.senderName) {
      return <RecipientsCell recipientName={notification?.senderName} />;
    }
    const recipients = notification.recipients?.map(r => r.userId);
    if (!recipients) return <Icon>remove</Icon>;
    return <RecipientsCell recipientUserIds={recipients} />;
  }

  const renderInboxRowActions = (notification: Notification) => {
    if (!(notification instanceof Notification)) return null;
    return (
      <RowActionsContainer>
        {!notification.isSeen(session.user?.id) ? (
          <Tooltip title="Mark as Read">
            <span>
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  void markAsRead(notification);
                }}
              >
                <MarkEmailReadIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title="Mark as Unread">
            <span>
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  void markAsUnread(notification);
                }}
              >
                <MarkEmailReadIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
        <Tooltip title="Archive">
          <span>
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                void archive(notification);
              }}
            >
              <ArchiveIcon />
            </IconButton>
          </span>
        </Tooltip>
      </RowActionsContainer>
    );
  };

  const renderArchiveRowActions = (communication: Notification) => {
    return (
      <RowActionsContainer>
        <Tooltip title="Restore from Archive">
          <span>
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                void unArchive(communication);
              }}
            >
              <UnarchiveIcon />
            </IconButton>
          </span>
        </Tooltip>
      </RowActionsContainer>
    );
  };

  async function markAsRead(communication: Notification) {
    if (!communication || communication?.seenAt(session.user?.id)) return;
    try {
      const updatedNotification = await new NotificationsAPIService(
        session
      ).markNotificationAsSeen(communication);
      dispatch(addNotification(updatedNotification));
    } catch (error) {
      if (error instanceof NotificationNotFoundError) {
        console.error(
          "Unable to mark a deleted notification as read ",
          error.id
        );
      } else {
        console.error(error);
      }
    }
  }

  async function markAsUnread(communication: Notification) {
    if (!communication?.seenAt(session.user?.id)) return;
    try {
      const updatedNotification = await new NotificationsAPIService(
        session
      ).markNotificationAsUnSeen(communication);
      dispatch(addNotification(updatedNotification));
    } catch (error) {
      if (error instanceof NotificationNotFoundError) {
        console.error(
          "Unable to mark a deleted notification as unread, refreshing to remove ",
          error.id
        );
      } else {
        console.error(error);
      }
    }
  }

  async function archive(communication: Notification) {
    if (!communication) return;
    try {
      await new NotificationsAPIService(session).archiveNotification(
        communication
      );
    } catch (error) {
      if (error instanceof NotificationNotFoundError) {
        console.error(
          "Unable to archive a deleted notification, refreshing to remove ",
          error.id
        );
      } else {
        console.error(error);
      }
      dispatch(
        updateNotificationInterfaceQuery({
          interfaceName: "communicationsIndex",
          query: notificationQuery,
        })
      );
    }
  }

  async function unArchive(communication: Notification) {
    if (!communication) return;
    try {
      await new NotificationsAPIService(session).unArchiveNotification(
        communication
      );
    } catch (error) {
      if (error instanceof NotificationNotFoundError) {
        console.error(
          "Unable to un-archive a deleted notification, refreshing to remove ",
          error.id
        );
      } else {
        console.error(error);
      }
      dispatch(
        updateNotificationInterfaceQuery({
          interfaceName: "communicationsIndex",
          query: notificationQuery,
        })
      );
    }
  }

  const columnHelper = createMRTColumnHelper<Notification>();
  const columns = [];
  if (activeTab !== BoxType.Forums) {
    columns.push(
      ...[
        columnHelper.accessor(
          renderCategoryColumn,
          {
            header: "Type",
            id: "type",
            enableSorting: false
          }
        ),
        columnHelper.accessor(
          renderFromColumn,
          {
            header: "From",
            id: "sender",
            enableSorting: false
          }
        ),
        columnHelper.accessor(
          renderToColumn,
          {
            header: "To",
            id: "recipients",
            enableSorting: false
          }
        ),
        columnHelper.accessor(
          renderDescriptionColumn,
          {
            header: "Description",
            id: "description",
            enableSorting: false
          }
        ),
      ]
    );
  }

  columns.push(
    columnHelper.accessor(
      renderCreatedDateColumn,
      {
        header: "Created",
        id: "createdDate",
      }
    )
  );

  function getRowClickTheme(notification: Notification): SxProps<Theme> | undefined {
    if (activeTab === BoxType.Archive) {
      return {
        cursor: "",
        backgroundColor: "rgba(0, 0, 0, 0.04)",
      };
    }

    return {
      cursor: "pointer",
      backgroundColor: Notification.isSeen(notification, session.user?.id) ? "rgba(0, 0, 0, 0.04)" : "inherit",
    };
  }

  const renderTopToolbarCustomActions = <T extends RowData,>(
    props: { table: TableInstance<T> },
    additional?: JSX.Element | undefined,
    filters?: JSX.Element | undefined,
  ): JSX.Element => {
    const { table } = props;

    return (
      <TableTopToolbarContainer>
        <TableTitleContainer>
          <TableTitle variant="h4">Communications</TableTitle>
          {isSmlDisplaySize && (
            <div>
              <ComposeMessageButton
                color="primary"
                onClick={() => navigate("/communications/forums/compose")}
              >
                <AddCommentIcon fontSize="large" />
              </ComposeMessageButton>
              <NewForumButton
                color="primary"
                onClick={() => navigate("/communications/forums/compose")}
              >
                <ForumIcon fontSize="large" />
              </NewForumButton>
            </div>
          )}
        </TableTitleContainer>
        <LowerTopToolbarContainer>
          <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(_event, newValue) =>
              navigate(`/communications/${newValue}`)
            }
          >
            <Tab value={BoxType.Inbox} label="Inbox" />
            <Tab value={BoxType.Outbox} label="Sent" />
            <Tab value={BoxType.Forums} label="Conversations" />
            <Tab value={BoxType.Archive} label="Archived" />
          </Tabs>
          {additional}
          {activeTab === BoxType.Inbox && (
            <FilterButtons>
              <Chip
                icon={<FilterListIcon />}
                label="Unread"
                color="primary"
                variant={filterByUnread ? "filled" : "outlined"}
                onClick={() => {
                  setFilterByUnread((prevState) => !prevState);
                  setSearchParams((prevParams) => {
                    const params = new URLSearchParams(prevParams);
                    if (!filterByUnread) {
                      params.set(
                        "unread",
                        "true"
                      );
                    } else {
                      params.delete("unread");
                    }
                    return params;
                  });
                }}
              />
              <Chip
                icon={<FilterListIcon />}
                label="Action Required"
                color="primary"
                variant={filterByActionRequired ? "filled" : "outlined"}
                onClick={() => {
                  setFilterByActionRequired((prevState) => !prevState);
                  setSearchParams((prevParams) => {
                    const params = new URLSearchParams(prevParams);
                    if (!filterByActionRequired) {
                      params.set(
                        "actionRequired",
                        "true"
                      );
                    } else {
                      params.delete("actionRequired");
                    }
                    return params;
                  });
                }}
              />
            </FilterButtons>
          )}
        </LowerTopToolbarContainer>
        {filters}
        {isMedDisplaySize && (
          <ToolbarButtonsContainer>
            <ToolbarButtons>
              <ToggleGlobalFilterButton table={table} />
              <ToggleFiltersButton table={table} />
              <ShowHideColumnsButton table={table} />
              <ToggleDensePaddingButton table={table} />
              <ToggleFullScreenButton table={table} />
            </ToolbarButtons>
          </ToolbarButtonsContainer>
        )}
      </TableTopToolbarContainer>
    );
  }

  const table = useMaterialReactTable({
    columns,
    data: tableData,
    rowCount: rowCount,
    enableRowSelection: activeTab !== BoxType.Forums,
    enableRowActions: activeTab !== BoxType.Forums,
    enableTableHead: true,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: () => { void navigateToTarget(row.original); },
      sx: getRowClickTheme(row.original),
    }),
    muiTableProps: () => ({
      sx: {
        height: notificationsResponse?.data?.length === 0 ? "100%" : "initial",
      },
    }),
    renderToolbarInternalActions: ({ table }) => (
      <>
        {!isMedDisplaySize && (
          <ToolbarButtonsContainer>
            <ToolbarButtons>
              <ToggleGlobalFilterButton table={table} />
              <ToggleFiltersButton table={table} />
              <ShowHideColumnsButton table={table} />
              <ToggleDensePaddingButton table={table} />
              <ToggleFullScreenButton table={table} />
            </ToolbarButtons>
            <ToolbarActionButtons>
              <Button
                color="primary"
                startIcon={<AddCommentIcon />}
                onClick={() => navigate("/communications/forums/compose")}
              >
                Compose Message
              </Button>
              <Button
                color="primary"
                startIcon={<ForumIcon />}
                onClick={() => navigate("/communications/forums/create")}
              >
                New Conversation
              </Button>
            </ToolbarActionButtons>
          </ToolbarButtonsContainer>
        )}
        {isMedDisplaySize && !isSmlDisplaySize && (
          <>
            <ComposeMessageButton
              color="primary"
              onClick={() => navigate("/communications/forums/compose")}
            >
              <AddCommentIcon fontSize="large" />
            </ComposeMessageButton>
            <NewForumButton
              color="primary"
              onClick={() => navigate("/communications/forums/create")}
            >
              <ForumIcon fontSize="large" />
            </NewForumButton>
          </>
        )}
      </>
    ),
    renderTopToolbarCustomActions: () => {
      return (
        <TableTopToolbarContainer>
          <TableTitleContainer>
            <TableTitle variant="h4">Communications</TableTitle>
            {isSmlDisplaySize && (
              <div>
                <ComposeMessageButton
                  color="primary"
                  onClick={() => navigate("/communications/forums/compose")}
                >
                  <AddCommentIcon fontSize="large" />
                </ComposeMessageButton>
                <NewForumButton
                  color="primary"
                  onClick={() => navigate("/communications/forums/compose")}
                >
                  <ForumIcon fontSize="large" />
                </NewForumButton>
              </div>
            )}
          </TableTitleContainer>
          <LowerTopToolbarContainer>
            <Tabs
              value={activeTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={(_event, newValue) =>
                navigate(`/communications/${newValue}`)
              }
            >
              <Tab value={BoxType.Inbox} label="Inbox" />
              <Tab value={BoxType.Outbox} label="Sent" />
              <Tab value={BoxType.Forums} label="Conversations" />
              <Tab value={BoxType.Archive} label="Archived" />
            </Tabs>
            {activeTab === BoxType.Inbox && (
              <FilterButtons>
                <Chip
                  icon={<FilterListIcon />}
                  label="Unread"
                  color="primary"
                  variant={filterByUnread ? "filled" : "outlined"}
                  onClick={() => {
                    setFilterByUnread((prevState) => !prevState);
                    setSearchParams((prevParams) => {
                      const params = new URLSearchParams(prevParams);
                      if (!filterByUnread) {
                        params.set(
                          "unread",
                          "true"
                        );
                      } else {
                        params.delete("unread");
                      }
                      return params;
                    });
                  }}
                />
                <Chip
                  icon={<FilterListIcon />}
                  label="Action Required"
                  color="primary"
                  variant={filterByActionRequired ? "filled" : "outlined"}
                  onClick={() => {
                    setFilterByActionRequired((prevState) => !prevState);
                    setSearchParams((prevParams) => {
                      const params = new URLSearchParams(prevParams);
                      if (!filterByActionRequired) {
                        params.set(
                          "actionRequired",
                          "true"
                        );
                      } else {
                        params.delete("actionRequired");
                      }
                      return params;
                    });
                  }}
                />
              </FilterButtons>
            )}
          </LowerTopToolbarContainer>
          {isMedDisplaySize && (
            <ToolbarButtonsContainer>
              <ToolbarButtons>
                <ToggleGlobalFilterButton table={table} />
                <ToggleFiltersButton table={table} />
                <ShowHideColumnsButton table={table} />
                <ToggleDensePaddingButton table={table} />
                <ToggleFullScreenButton table={table} />
              </ToolbarButtons>
            </ToolbarButtonsContainer>
          )}
        </TableTopToolbarContainer>
      );
    },
    renderRowActions: ({ row }) => {
      if (activeTab === BoxType.Archive) {
        return renderArchiveRowActions(row.original);
      }
      if (activeTab === BoxType.Inbox) {
        return renderInboxRowActions(row.original);
      }
    },
    renderEmptyRowsFallback: () => {
      if (isLoading) {
        return;
      }
      return (
        <NoRowsContainer>
          <AllCaughtUp alt="All Caught Up" src={EmptyInboxPlaceholder} />
        </NoRowsContainer>
      );
    },
    getRowId: (row) => row.id?.toString() ?? Guid.generate().toString(),
    initialState: {
      columnPinning: { right: ["mrt-row-actions"] },
      columnOrder: [
        "type",
        "sender",
        "recipients",
        "description",
        "message",
        "conversationName",
        "createdDate",
        "actions"
      ],
    },
    manualFiltering: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnPinning: true,
    manualPagination: true,
    manualSorting: true,
    muiTableContainerProps: ({ table }) => ({
      sx: {
        height: `calc(100% - ${table.refs.topToolbarRef.current?.offsetHeight}px - ${table.refs.bottomToolbarRef.current?.offsetHeight}px)`,
      },
    }),
    muiTablePaperProps: {
      sx: {
        height: "100%",
      },
    },
    muiToolbarAlertBannerProps: showAlertBanner
      ? {
        color: "error",
        title: errorLoadingQuery || ""
      }
      : {
        action: (
          <AlertActions>
            {activeTab === BoxType.Archive && (
              <Button
                color="primary"
                startIcon={<UnarchiveIcon />}
                onClick={unArchiveMultiple}
              >
                Un-Archive
              </Button>
            )}
            {activeTab === BoxType.Inbox && (
              <>
                <Button
                  color="primary"
                  startIcon={<MarkEmailReadIcon />}
                  onClick={markMultipleSeen}
                >
                  Mark Read
                </Button>
                <Button
                  color="primary"
                  startIcon={<MarkEmailUnreadIcon />}
                  onClick={markMultipleUnseen}
                >
                  Mark Unread
                </Button>
              </>
            )}
            {activeTab !== BoxType.Archive && (
              <Button
                color="primary"
                startIcon={<ArchiveIcon />}
                onClick={archiveMultiple}
              >
                Archive
              </Button>
            )}
          </AlertActions>
        ),
      },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onRowSelectionChange: setRowSelection,
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner,
      showProgressBars,
      sorting,
      rowSelection,
      showSkeletons
    },
  });

  if (!session.user?.companyEntityId) {
    return (<NotAuthorized />);
  }

  if (activeTab === BoxType.Forums) {
    return <ConversationTable
      renderTopToolbarCustomActions={renderTopToolbarCustomActions} />;
  }
  else
    return <MaterialReactTable table={table} />;
}
